import { Navigate } from "react-router";
import { Body, H1 } from "@datapay-by-datacom/design-system";
import { WorkPatternImportInput } from "../components/WorkPatternImport/WorkPatternImportInput";
import { useWorkPatternImportEnabled } from "../hooks/useWorkPatternImportEnabled";
import { useWorkPatternImportRedesignEnabled } from "../hooks/useWorkPatternImportRedesignEnabled";
import styles from "./WorkPatternImportScreen.module.css";

/**
 * Default screen for the work-pattern import portal.
 *
 * Renders a page heading and the top-level import flow composition:
 *   CSV drop → client parse → validate pre-flight → commit.
 *
 * Nested inside `OnboardingLayout` (`enable-onboarding`); this screen also
 * gates on `enable-work-pattern-import` so a direct URL is blocked when off.
 */
export function WorkPatternImportScreen() {
  const { isLoaded, areFlagsOn } = useWorkPatternImportEnabled();
  const redesignEnabled = useWorkPatternImportRedesignEnabled();

  if (!isLoaded) {
    return null;
  }

  if (!areFlagsOn) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <H1>Work Pattern Import</H1>
        <Body className={styles.pageSubtitle}>
          Upload a CSV file to bulk-import work patterns for a company. Rows
          are validated before committing — you can review any issues before
          confirming.
        </Body>
      </header>

      <WorkPatternImportInput redesignEnabled={redesignEnabled} />
    </div>
  );
}
